export const PRODUCT_PRICING_SIZE = {
  SMALL: 'small',
  SMALL_PLUS: 'smallPlus',
  MEDIUM: 'medium',
  DEFAULT: 'default',
} as const;
export type ProductPricingSize = ValueOf<typeof PRODUCT_PRICING_SIZE>;
